/**
 * Função para normalizar e remover todos os acentos de uma string
 *
 * @param text string que deve ser normalizada
 * @returns {string} uma nova string normalizada e sem acentos
 */

export const normalizeText = (text: string): string => {
  return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
}
